import privacyMarkdown from '../../legal-docs/privacy-2026-08-24-dpdp.md?raw';
import termsMarkdown from '../../legal-docs/terms-2026-08-24-dpdp.md?raw';
import { parseLegalMarkdown } from './parseLegalMarkdown';

export type LegalSection = {
    heading: string;
    paragraphs: string[];
    bullets?: string[];
};

export type LegalDocumentBody = {
    title: string;
    version: string;
    effectiveDate: string;
    intro: string;
    counselSigned: boolean;
    sections: LegalSection[];
};

export const PRIVACY_POLICY: LegalDocumentBody = parseLegalMarkdown(privacyMarkdown);
export const TERMS_OF_USE: LegalDocumentBody = parseLegalMarkdown(termsMarkdown);
